import { render, staticRenderFns } from "./TransPro.vue?vue&type=template&id=6407e86d&scoped=true&"
import script from "./TransPro.vue?vue&type=script&lang=js&"
export * from "./TransPro.vue?vue&type=script&lang=js&"
import style0 from "./TransPro.vue?vue&type=style&index=0&id=6407e86d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6407e86d",
  null
  
)

export default component.exports